/* Quick add from product grid variant dropdown. Moved out of theme.liquid (audit Oct 2026). */
document.addEventListener('click', function(e) {
  if (e.target.classList.contains('variant-add-to-cart-btn')) {
    e.preventDefault();
    e.stopPropagation();

    const dropdown = e.target.closest('.variant-selector-container').querySelector('.variant-dropdown');
    const variantId = dropdown.value;

    if (variantId) {
      const productItem = e.target.closest('.product-item, .product-grid-item');
      const workingAddButton = productItem.querySelector('[data-add-to-cart]');

      if (workingAddButton) {
        const variantInput = productItem.querySelector('.variant_idd');
        if (variantInput) {
          variantInput.value = variantId;
        }
        workingAddButton.click();
      } else {
        addToCartWithAjax(variantId);
      }
    }
  }
});

function addToCartWithAjax(variantId) {
  const addButton = document.querySelector('.variant-add-to-cart-btn[data-variant-id="' + variantId + '"]');
  const originalText = addButton.textContent;
  addButton.textContent = 'Adding...';
  addButton.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
  })
  .then(response => response.json())
  .then(data => {
    addButton.textContent = originalText;
    addButton.disabled = false;
    updateCartCount();
    try {
      if (typeof openCartDrawerOnProductAdded === 'function') {
        openCartDrawerOnProductAdded();
      } else {
        document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
      }
    } catch (error) {
      console.error('Error opening cart drawer:', error);
    }
  })
  .catch(error => {
    console.error('Error:', error);
    addButton.disabled = false;
    addButton.textContent = 'Could not add, try again';
    setTimeout(function () { addButton.textContent = originalText; }, 2500);
  });
}

function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      document.querySelectorAll('.header__cart__status, .cart-count').forEach(element => {
        element.textContent = cart.item_count;
      });
    });
}

document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('variant-dropdown')) {
      const addButton = e.target.closest('.variant-selector-container').querySelector('.variant-add-to-cart-btn');
      addButton.disabled = !e.target.value;
      if (e.target.value) {
        addButton.setAttribute('data-variant-id', e.target.value);
      }
    }
  });
});
